import { filter, Observable } from "rxjs";

type inputType = null | undefined;

export function inputIsNotNullOrUndefined<T>(input: inputType | T): input is T {
  return input !== null && input !== undefined;
}

export function getDefinedOrEmpty<T>(input: inputType | T): T | "" {
  if (input === null || input === undefined) {
    return "";
  } else {
    return input;
  }
}

export function filterTruthy<T>() {
  return (source$: Observable<inputType | T>) =>
    source$.pipe(filter(inputIsNotNullOrUndefined));
}
